import React from 'react'

export default (props) => {
	if (!props.user || (props.user && !props.user.accountPaid)) {
		return (
			<div>
				<div className='capps-height-20' />
				<div
					className='capps-lifepurposeapp'
					onTouchTap={() => { window.open('https://www.LifePurposeApp.com', '_system') }}
				>
					Click here to discover Dan Millman’s
					<div className='capps-lifepurposeapp-image' />
					<div className='capps-lifepurposeapp-ad'>advertisement</div>
				</div>
			</div>
		)
	}
	return null
}



// WEBPACK FOOTER //
// ./src/Components/Footer/LifePurposeApp.js